/**
 * Dropdown Edge-Flip für die Desktop-Header-Navigation.
 *
 * Problem: .header__dropdown-menu ist absolut positioniert (linksbündig am
 * Menüpunkt) ohne Viewport-Kollisionserkennung. Bei Menüpunkten nahe am
 * rechten Viewport-Rand läuft das Dropdown aus dem sichtbaren Bereich.
 *
 * Lösung: Beim Öffnen eines <details.header__menu-disclosure> wird das
 * zugehörige Dropdown gemessen.
 * - Top-Level-Dropdown: um den Überlauf nach links verschoben (translate).
 * - Verschachteltes Flyout (öffnet rechts neben dem Parent): klappt per
 *   Klasse .mm-flip-left auf die linke Seite (CSS in custom-th-theme.css).
 *
 * Das toggle-Event von <details> bubbelt nicht — daher Capture-Listener.
 */
(function () {
  var EDGE_GAP = 8; // px Mindestabstand zum Viewport-Rand

  function adjust(details) {
    var menu = details.querySelector(':scope > .header__dropdown-menu');
    if (!menu) return;

    // Reset, damit Messung und erneutes Öffnen sauber starten
    menu.style.translate = '';
    menu.classList.remove('mm-flip-left');

    if (!details.open) return;

    var isNested = !!menu.parentElement.closest('.header__dropdown-menu');
    var rect = menu.getBoundingClientRect();
    if (rect.width === 0) return; // nicht gerendert (z.B. Mobile-Drawer)

    var overflow = rect.right - (window.innerWidth - EDGE_GAP);
    if (overflow <= 0) return;

    if (isNested) {
      menu.classList.add('mm-flip-left');
    } else {
      menu.style.translate = -overflow + 'px';
    }
  }

  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (!details.matches || !details.matches('.header__primary-nav .header__menu-disclosure')) return;
    requestAnimationFrame(function () { adjust(details); });
  }, true);

  // Offene Dropdowns bei Resize nachjustieren
  window.addEventListener('resize', function () {
    document.querySelectorAll('.header__primary-nav .header__menu-disclosure[open]').forEach(adjust);
  });
})();
